import { apolloReducer as apollo } from 'apollo-cache-redux';
import form from 'redux-form/lib/reducer';
import table from './table';
import select from './select';
import enable from './enable';

export default {
  apollo,
  form,
  table,
  select,
  enable,
};



// WEBPACK FOOTER //
// ./src/data/reducers/index.js